import { Link } from 'react-router-dom';

export default function FooterSection() {
  return (
    <footer className="w-full py-12 px-4" style={{ backgroundColor: '#EDE7DC' }}>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <p className="font-serif text-[#3A3530] text-2xl italic tracking-widest mb-1">sanctuary</p>
          <p className="font-sans text-[#8B8480] text-xs tracking-widest">埼玉県川口市・カウンセリングサロン</p>
        </div>

        <div className="flex justify-center gap-8 mb-8">
          <Link to="/legal" className="cursor-pointer font-sans text-[#6B6460] text-xs hover:text-[#3A3530] transition-colors tracking-wide">
            特定商取引法に基づく表記
          </Link>
          <Link to="/privacy" className="cursor-pointer font-sans text-[#6B6460] text-xs hover:text-[#3A3530] transition-colors tracking-wide">
            プライバシーポリシー
          </Link>
        </div>

        <div
          className="rounded-lg p-5 mb-8 text-center"
          style={{ backgroundColor: 'rgba(255,255,255,0.5)', border: '1px solid rgba(194,168,130,0.3)' }}
        >
          <p className="font-sans text-[#8B8480] text-xs leading-relaxed">
            ※ sanctuary は医療機関ではありません。心理カウンセリングやセラピーは医療行為ではなく、<br className="hidden md:block" />
            医師による診断・治療の代替となるものではありません。<br />
            精神疾患の治療が必要な方は、医療機関へのご相談をおすすめします。
          </p>
        </div>

        <p className="font-sans text-[#B0A89E] text-xs text-center tracking-wider">
          © 2026 sanctuary. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
